export default __webpack_public_path__ + "static/media/thecryptobushi.8f1e3d9f.png";